export class WebAppInfo {
 public readonly appVersion = "1.5.27 (7)";

}
